var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { injectable } from '../../../Data/Decorators/Injectable';
import { inject } from '../../../Data/Decorators/Inject';
import { IConfigurationRepositoryType } from '../../UseCases/Configuration/IConfigurationRepository';
import { Application } from '../../../Application';
let InstructionsService = class InstructionsService {
    constructor(configurationRepository) {
        this.configurationRepository = configurationRepository;
        this.map = new Map();
    }
    executeInstructions(instructions, processing) {
        if (!processing) {
            instructions.forEach(instruction => {
                instruction.active = false;
            });
        }
        if (instructions.length <= 0) {
            return Promise.resolve();
        }
        if (instructions[instructions.length - 1].active) {
            return Promise.resolve();
        }
        const active_index = instructions.findIndex(instruction => instruction.active);
        if (instructions[active_index]) {
            instructions[active_index].active = undefined;
        }
        if (!instructions[active_index + 1]) {
            return Promise.resolve();
        }
        instructions[active_index + 1].active = true;
        return this.executeInstruction(instructions[active_index + 1])
            .then(() => this.executeInstructions(instructions, true))
            .catch(error => {
            console.warn(error);
            instructions[active_index + 1].active = undefined;
            if (instructions[active_index - 1]) {
                instructions[active_index - 1].active = true;
            }
            return this.executeInstructions(instructions, true);
        });
    }
    executeInstruction(instruction) {
        return this.getAction(instruction.action)
            .then(instance => instance.execute(instruction.data))
            .then(() => undefined);
    }
    executeApplicationInstructions(fallback_instructions) {
        const instructions = this.configurationRepository.getInstructions();
        return instructions.length > 0
            ? this.executeInstructions(instructions)
            : this.executeInstructions(fallback_instructions || []);
    }
    getAction(action) {
        const dep = this.map.get(action);
        if (dep === null || dep === void 0 ? void 0 : dep.instance) {
            return Promise.resolve(dep.instance);
        }
        const provider = Application.providers.loadProviderByAction(action);
        if (!provider) {
            return Promise.reject(new Error(`Unable to find action ${action.toString()}!`));
        }
        return provider.resolveByAction(action)
            .then(instance => {
            if (!instance) {
                return Promise.reject(new Error(`Unable to create use case for action ${action.toString()}!`));
            }
            if (!instance.execute) {
                return Promise.reject(new Error(`Use case for action ${action.toString()} is invalid! Execute is missing!`));
            }
            this.map.set(action, { provider, instance });
            return instance;
        });
    }
    onDestroy() {
        Array.from(this.map.values()).forEach(dep => dep.provider.destroyInstance(dep.instance));
    }
};
InstructionsService = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IConfigurationRepositoryType)),
    __metadata("design:paramtypes", [Object])
], InstructionsService);
export { InstructionsService };
